<simple-notifications></simple-notifications>
<ion-app>
  <ion-tabs data-test-id="q267zewgvb-ion-tabs">
    <ion-tab-bar [class.d-none]="hideTabs" class="sm-bg-gray-filled-100" slot="bottom">
      <ion-tab-button [tab]="NavigationUrls.ScheduleView" class="sm-bg-gray-filled-100" data-test-id="7205rjzxf3-ion-tab-button">
        <span class="material-symbols-outlined sm-mat-icon-normal icon-large">date_range</span>
        <ion-label class="tab-label" data-test-id="jobs-tab-label">Jobs</ion-label>
      </ion-tab-button>
      <ion-tab-button [tab]="NavigationUrls.JobHistory" class="sm-bg-gray-filled-100" data-test-id="p1t5n96tbm-ion-tab-button">
        <span class="material-symbols-outlined sm-mat-icon-normal icon-large">history</span>
        <ion-label class="tab-label" data-test-id="job-history-tab-label">Job History</ion-label>
      </ion-tab-button>
      @if (showWarehouseTab) {
        <ion-tab-button [tab]="NavigationUrls.Warehouse" class="sm-bg-gray-filled-100 warehouse-tab" data-test-id="warehouse-ion-tab-button">
          <span class="material-symbols-outlined sm-mat-icon-normal icon-large">warehouse</span>
          <ion-label class="tab-label" data-test-id="warehouse-tab-label">Warehouse</ion-label>
          <!-- Badge is inert for now (warehousePendingCount = 0); renders once a real count is wired. -->
          @if (warehousePendingCount > 0) {
            <ion-badge class="warehouse-badge">{{ warehousePendingCount }}</ion-badge>
          }
        </ion-tab-button>
      }
      <ion-tab-button class="sm-bg-gray-filled-100" data-test-id="39wk28snqe-ion-tab-button" tab="settings">
        <span class="material-symbols-outlined sm-mat-icon-normal icon-large">settings</span>
        <ion-label class="tab-label" data-test-id="settings-tab-label">Settings</ion-label>
      </ion-tab-button>
    </ion-tab-bar>
  </ion-tabs>
</ion-app>
